import { QUALIFICATIONS_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";

export const QualificationsService = {
  getAll: (params: any) => requests.get(`${QUALIFICATIONS_URL}`, params),
  create: (params: any) => requests.post(`${QUALIFICATIONS_URL}`, params),
  getSingle: (id: number) => requests.get(`${QUALIFICATIONS_URL}/${id}`),
  update: (params: any, id: number) => requests.put(`${QUALIFICATIONS_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${QUALIFICATIONS_URL}/${id}`),
};